import styled, { css } from "styled-components";
import Flex from "../../../agent-service/ui/atoms/Flex";
import { SLIDER_DATA } from "../../api/constant";
import { useTranslations } from "next-intl";
import Marquee from "react-fast-marquee";
import { useEffect, useRef, useState } from "react";

interface SliderData {
  userimg: string;
  companyImage: React.ReactNode;
  desc: string;
  name: string;
  role: string;
}

const ReviewSlider = () => {
  const t = useTranslations();
  const sectionRefs = useRef<(HTMLDivElement | null)[]>([]);
  const [maxHeight, setMaxHeight] = useState<number>(0);

  const addToRefs = (el: HTMLDivElement | null) => {
    if (el && !sectionRefs.current.includes(el)) {
      sectionRefs.current.push(el);
    }
  };

  useEffect(() => {
    if (sectionRefs.current.length) {
      const heights = sectionRefs.current.map(
        (ref) => ref?.getBoundingClientRect().height || 0
      );
      setMaxHeight(Math.max(...heights));
    }
  }, [sectionRefs.current]);

  const ALL_SLIDER_DATA: SliderData[] = Array(5).fill(SLIDER_DATA).flat();

  return (
    <TickerContainer $fullwidth>
      <StyledMarquee pauseOnHover speed={50}>
        {ALL_SLIDER_DATA.map((data, index) => (
          <SliderSection
            key={index}
            direction="column"
            ref={addToRefs}
            style={{ height: `${maxHeight}px` }}
          >
            <ImageWrap alignitems="center">
              <img src={data.userimg} alt="User" />
              {data.companyImage}
            </ImageWrap>
            <TextWrp>{t(data.desc)}</TextWrp>
            <RoleInfo>
              <span>{t(data.name)}</span> {t(data.role)}
            </RoleInfo>
          </SliderSection>
        ))}
      </StyledMarquee>
    </TickerContainer>
  );
};

export default ReviewSlider;

const textBaseStyle = `
  color: #000;
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
`;

const RoleInfo = styled(Flex)`
  ${textBaseStyle}
  margin-top: auto;

  span {
    font-variant-numeric: slashed-zero;
    font-weight: 600;
    margin-right: ${({ theme: { isRTL } }) => (isRTL ? "0" : "8px")};
    margin-left: ${({ theme: { isRTL } }) => (isRTL ? "8px" : "0")};
  }
`;

const TextWrp = styled.div`
  ${textBaseStyle}
`;

const ImageWrap = styled(Flex)`
  gap: 16px;
`;

const SliderSection = styled(Flex)`
  display: flex !important;
  padding: 32px;
  border-radius: 24px;
  border: 1px solid #e4e5e9;
  min-height: 280px;
  gap: 24px;
  min-width: 340px;
  max-width: 340px;
  cursor: pointer;
  ${({ theme: { isRTL } }) => css`
    ${isRTL &&
    css`
      direction: rtl;
    `}
  `}
`;

const StyledMarquee = styled(Marquee)`
  display: flex;
  gap: 16px;

  .rfm-marquee {
    min-width: fit-content;
  }

  .rfm-initial-child-container,
  .rfm-marquee {
    gap: 16px;
  }
`;

const TickerContainer = styled(Flex)`
  max-width: 100%;
  overflow: hidden;
`;
